export default __webpack_public_path__ + "static/enterprise-72ac91cd166c08a4fe85593957ca0072.png";